<section class="gw-mx-auto gw-w-full gw-max-w-[1600px]">
  <div
    class="gw-grid gw-grid-cols-1 md:gw-grid-cols-[1fr_436px] md:gw-min-h-[calc(100vh-56px)] gw-p-small md:gw-p-[0px]"
  >
    <div class="main-column md:gw-pr-medium gw-py-x-large">
      <div class="gw-mb-x-large gw-gap-[8px] gw-flex gw-flex-col">
        <h1 class="gw-text-text-primary gw-text-[32px]">
          {{ 'features.dashboard.recipient.pageTitle' | translate }}
        </h1>
        <span class="gw-text-text-secondary gw-text-[14px]">
          {{ 'features.dashboard.recipient.pageSubtitle' | translate }}
        </span>
      </div>

      <div
        class="wallet-carousel-shell"
        [class.wallet-carousel-shell--active]="hasMultipleWallets"
      >
        <button
          *ngIf="hasMultipleWallets"
          type="button"
          class="wallet-carousel__arrow wallet-carousel__arrow--outside"
          (click)="selectPreviousWallet()"
          [attr.aria-label]="
            'features.dashboard.recipient.walletSelector.previous' | translate
          "
        >
          <gatewee-icon
            icon="@tui.chevron-left"
            size="18px"
            iconStyle="primary"
          ></gatewee-icon>
        </button>

        <div class="card" [class.gw-mb-x-large]="!hasMultipleWallets">
          <div class="gw-p-small md:gw-p-medium gw-relative gw-z-[1]">
            <ng-container *ngIf="hasMultipleWallets; else singleWalletView">
              <div class="wallet-carousel__viewport">
                <div
                  class="wallet-carousel__track"
                  [style.transform]="
                    'translateX(-' + walletCarouselIndex * 100 + '%)'
                  "
                >
                  <div
                    *ngFor="
                      let option of walletSelectorOptions;
                      trackBy: trackByWalletKey
                    "
                    class="wallet-carousel__slide"
                    role="group"
                    [attr.aria-label]="option.label"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        walletCardBody;
                        context: {
                          slideWallet: walletForKey(option.key),
                          slideLabel: option.label,
                        }
                      "
                    ></ng-container>
                  </div>
                </div>
              </div>

              <div
                *ngIf="walletSelectorOptions.length > 1"
                class="wallet-carousel__dots gw-flex gw-items-center gw-justify-center gw-gap-[6px] gw-mt-small"
              >
                <button
                  *ngFor="
                    let option of walletSelectorOptions;
                    let index = index;
                    trackBy: trackByWalletKey
                  "
                  type="button"
                  class="wallet-carousel__dot"
                  [class.wallet-carousel__dot--active]="
                    index === walletCarouselIndex
                  "
                  [attr.aria-label]="option.label"
                  [attr.aria-current]="index === walletCarouselIndex"
                  (click)="goToWalletSlide(index)"
                ></button>
              </div>
            </ng-container>

            <ng-template #singleWalletView>
              <ng-container
                *ngTemplateOutlet="
                  walletCardBody;
                  context: {slideWallet: wallet, slideLabel: null}
                "
              ></ng-container>
            </ng-template>

            <ng-template
              #walletCardBody
              let-slideWallet="slideWallet"
              let-slideLabel="slideLabel"
            >
              <div class="gw-flex gw-flex-col gw-mb-small md:gw-mb-medium">
                <span
                  class="gw-text-[11px] md:gw-text-[12px] gw-font-bold gw-text-text-primary-on-accent-1"
                >
                  {{
                    slideWallet?.recipient?.name ||
                      slideWallet?.domain?.name ||
                      '-' | reduceName : 32
                  }}
                </span>
                <span
                  class="gw-text-[11px] md:gw-text-[12px] gw-font-medium gw-text-text-primary-on-accent-1"
                >
                  {{
                    slideWallet?.recipient?.document ||
                      slideWallet?.domain?.document ||
                      '-' | document : true
                  }}
                </span>
              </div>

              <p
                *ngIf="slideLabel"
                class="gw-m-0 gw-mb-small md:gw-mb-medium gw-text-[12px] md:gw-text-[13px] gw-font-semibold gw-text-text-primary-on-accent-1 gw-truncate"
              >
                {{ slideLabel }}
              </p>

              <div
                class="gw-flex gw-flex-col gw-gap-small md:gw-gap-x-large gw-mb-[20px] md:gw-mb-[32px]"
              >
                <span
                  class="gw-text-[13px] md:gw-text-[14px] gw-font-light gw-text-text-primary-on-accent-1"
                  >{{
                    'features.dashboard.cards.mainBalance' | translate
                  }}</span
                >
                <span
                  class="gw-text-[28px] md:gw-text-[40px] gw-font-bold gw-text-text-primary-on-accent-1"
                  [gwCountUp]="slideWallet?.availableBalance ?? 0"
                  [gwCountUpFormatter]="formatBrl"
                ></span>
              </div>
            </ng-template>
          </div>
          <div
            class="section-divider card__footer gw-relative gw-bg-background-neutral-2-hover gw-z-[1]"
          >
            <div
              class="gw-p-small md:gw-p-medium gw-grid gw-grid-cols-2 md:gw-grid-cols-4 gw-gap-small"
            >
              <button
                type="button"
                (click)="openPixDrawer()"
                class="card__action-btn gw-p-2x-small gw-text-stone-950 gw-bg-stone-50 gw-flex gw-gap-2x-small gw-justify-center gw-h-[48px] gw-text-[13px] md:gw-text-[14px] gw-font-bold gw-w-full gw-rounded-2xl gw-cursor-pointer gw-transition-all gw-duration-200 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
                *ngIf="'withdrawal.write' | permission"
              >
                <gatewee-icon
                  icon="@phi.pix-logo"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>

                <p>
                  {{
                    'features.dashboard.recipient.quickActions.pix' | translate
                  }}
                </p>
              </button>
              <button
                type="button"
                (click)="openBillPaymentDrawer()"
                class="card__action-btn gw-p-2x-small gw-text-stone-950 gw-bg-stone-50 gw-flex gw-gap-2x-small gw-justify-center gw-h-[48px] gw-text-[13px] md:gw-text-[14px] gw-font-bold gw-w-full gw-rounded-2xl gw-cursor-pointer gw-transition-all gw-duration-200 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
                *ngIf="
                  isBankSlipPaymentEnabled && ('withdrawal.write' | permission)
                "
              >
                <gatewee-icon
                  icon="@phi.invoice"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
                <p>
                  {{
                    'features.dashboard.recipient.quickActions.accounts'
                      | translate
                  }}
                </p>
              </button>
              <button
                type="button"
                disabled
                [attr.title]="
                  'features.dashboard.recipient.quickActions.comingSoon'
                    | translate
                "
                class="card__action-btn gw-p-2x-small gw-text-stone-950 gw-bg-stone-50 gw-flex gw-gap-2x-small gw-justify-center gw-h-[48px] gw-text-[13px] md:gw-text-[14px] gw-font-bold gw-w-full gw-rounded-2xl gw-cursor-not-allowed gw-opacity-50 gw-transition-all gw-duration-200 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
              >
                <gatewee-icon
                  icon="@phi.barcode"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
                <p>
                  {{
                    'features.dashboard.recipient.quickActions.bankSlips'
                      | translate
                  }}
                </p>
              </button>
              <button
                type="button"
                disabled
                [attr.title]="
                  'features.dashboard.recipient.quickActions.comingSoon'
                    | translate
                "
                class="card__action-btn gw-p-2x-small gw-text-stone-950 gw-bg-stone-50 gw-flex gw-gap-2x-small gw-justify-center gw-h-[48px] gw-text-[13px] md:gw-text-[14px] gw-font-bold gw-w-full gw-rounded-2xl gw-cursor-not-allowed gw-opacity-50 gw-transition-all gw-duration-200 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
              >
                <gatewee-icon
                  icon="@phi.files"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>

                <p>
                  {{
                    'features.dashboard.recipient.quickActions.charges'
                      | translate
                  }}
                </p>
              </button>
            </div>
          </div>
        </div>

        <button
          *ngIf="hasMultipleWallets"
          type="button"
          class="wallet-carousel__arrow wallet-carousel__arrow--outside"
          (click)="selectNextWallet()"
          [attr.aria-label]="
            'features.dashboard.recipient.walletSelector.next' | translate
          "
        >
          <gatewee-icon
            icon="@tui.chevron-right"
            size="18px"
            iconStyle="primary"
          ></gatewee-icon>
        </button>
      </div>

      <!-- Mobile -->
      <ng-container
        *ngTemplateOutlet="
          notificationPreview;
          context: {shellClass: 'gw-block md:gw-hidden'}
        "
      ></ng-container>

      <div
        class="gw-flex md:gw-hidden gw-h-[36px] gw-bg-background-elevation-2 gw-rounded-2xl gw-justify-between gw-p-2x-small"
      >
        <button
          type="button"
          (click)="mobileDashboardTab = 'faturamento'"
          class="gw-flex-1 gw-rounded-xl gw-text-[13px] gw-font-medium gw-transition-colors gw-duration-200"
          [class.gw-bg-[#80B4F11F]]="mobileDashboardTab === 'faturamento'"
          [class.gw-text-brand-primary]="mobileDashboardTab === 'faturamento'"
          [class.gw-text-text-secondary]="mobileDashboardTab !== 'faturamento'"
        >
          {{ 'features.dashboard.recipient.mobileTab.revenue' | translate }}
        </button>
        <button
          type="button"
          (click)="mobileDashboardTab = 'atividade'"
          class="gw-flex-1 gw-rounded-xl gw-text-[13px] gw-font-medium gw-transition-colors gw-duration-200"
          [class.gw-bg-[#80B4F11F]]="mobileDashboardTab === 'atividade'"
          [class.gw-text-brand-primary]="mobileDashboardTab === 'atividade'"
          [class.gw-text-text-secondary]="mobileDashboardTab !== 'atividade'"
        >
          {{ 'features.dashboard.recipient.mobileTab.activity' | translate }}
        </button>
      </div>

      <div
        *ngIf="!isMobile || mobileDashboardTab === 'faturamento'"
        [@mobileTabPanel]
        class="gw-flex gw-flex-col"
      >
        <div
          class="gw-flex gw-flex-col gw-border-base gw-mt-x-large md:gw-mt-[0px]"
        >
          <div
            class="gw-flex gw-flex-col md:gw-flex-row gw-justify-between gw-items-start md:gw-items-center gw-gap-small gw-p-small md:gw-p-medium"
          >
            <div class="gw-gap-[8px] gw-flex gw-flex-col">
              <h2 class="gw-text-text-primary gw-text-[14px]">
                {{
                  'features.dashboard.recipient.kpi.sectionTitle' | translate
                }}
              </h2>
              <span class="gw-text-text-secondary gw-text-[14px]">
                {{
                  'features.dashboard.recipient.kpi.sectionSubtitle' | translate
                }}
              </span>
              <span
                class="gw-text-text-primary gw-text-[13px] gw-font-semibold gw-mt-2x-small"
              >
                {{ selectedCompetenceLabel }}
              </span>
              <span class="gw-text-text-secondary gw-text-[12px]">
                {{
                  'features.dashboard.recipient.kpi.monthlyCompetenceHint'
                    | translate
                }}
              </span>
            </div>

            <div class="gw-border-base gw-flex gw-rounded-[10px]">
              <button
                type="button"
                (click)="selectedMonth = 'current'"
                class="period-btn period-btn--first gw-px-[10px] gw-py-[8px] gw-text-[13px] gw-font-medium gw-cursor-pointer gw-transition-all gw-duration-200"
                [class.gw-text-brand-primary]="selectedMonth === 'current'"
                [class.gw-bg-[#80B4F11F]]="selectedMonth === 'current'"
                [class.period-btn--active]="selectedMonth === 'current'"
                [class.gw-text-text-secondary]="selectedMonth !== 'current'"
                [class.gw-bg-transparent]="selectedMonth !== 'current'"
              >
                {{ currentMonthAbbrevLabel }}
              </button>
              <button
                type="button"
                (click)="selectedMonth = 'previous'"
                class="period-btn period-btn--middle gw-px-[10px] gw-py-[8px] gw-text-[13px] gw-font-medium gw-cursor-pointer gw-transition-all gw-duration-200"
                [class.gw-text-brand-primary]="selectedMonth === 'previous'"
                [class.gw-bg-[#80B4F11F]]="selectedMonth === 'previous'"
                [class.period-btn--active]="selectedMonth === 'previous'"
                [class.gw-text-text-secondary]="selectedMonth !== 'previous'"
                [class.gw-bg-transparent]="selectedMonth !== 'previous'"
              >
                {{ previousMonthAbbrevLabel }}
              </button>
              <button
                type="button"
                (click)="selectedMonth = 'twoMonthsAgo'"
                class="period-btn period-btn--last gw-px-[10px] gw-py-[8px] gw-text-[13px] gw-font-medium gw-cursor-pointer gw-transition-all gw-duration-200"
                [class.gw-text-brand-primary]="selectedMonth === 'twoMonthsAgo'"
                [class.gw-bg-[#80B4F11F]]="selectedMonth === 'twoMonthsAgo'"
                [class.period-btn--active]="selectedMonth === 'twoMonthsAgo'"
                [class.gw-text-text-secondary]="
                  selectedMonth !== 'twoMonthsAgo'
                "
                [class.gw-bg-transparent]="selectedMonth !== 'twoMonthsAgo'"
              >
                {{ twoMonthsAgoAbbrevLabel }}
              </button>
            </div>
          </div>

          <div class="section-divider">
            <div
              class="gw-bg-background-neutral-1 gw-m-small md:gw-m-medium gw-grid gw-grid-cols-2 md:gw-grid-cols-3 xl:gw-grid-cols-5 gw-gap-small md:gw-gap-0 gw-rounded-2xl"
            >
              <div
                class="metric-divider gw-p-small md:gw-p-medium gw-flex gw-flex-col gw-gap-3x-small"
              >
                <span
                  class="gw-text-text-secondary gw-text-[13px] md:gw-text-[14px]"
                  >{{
                    'features.dashboard.recipient.kpi.grossRevenue' | translate
                  }}</span
                >
                <span
                  class="gw-text-text-positive gw-text-[14px] md:gw-text-[16px] gw-font-bold"
                  >{{
                    formatCurrency(+(selectedStat?.incomeGrossVolume ?? 0))
                  }}</span
                >
              </div>
              <div
                class="metric-divider gw-p-small md:gw-p-medium gw-flex gw-flex-col gw-gap-3x-small"
              >
                <span
                  class="gw-text-text-secondary gw-text-[13px] md:gw-text-[14px]"
                  >{{
                    'features.dashboard.recipient.kpi.cashOutSettled'
                      | translate
                  }}</span
                >
                <span
                  class="gw-text-text-negative gw-text-[14px] md:gw-text-[16px] gw-font-bold"
                  >{{
                    formatCurrency(+(selectedStat?.cashOutSettledVolume ?? 0))
                  }}</span
                >
              </div>
              <div
                class="metric-divider gw-p-small md:gw-p-medium gw-flex gw-flex-col gw-gap-3x-small"
              >
                <span
                  class="gw-text-text-secondary gw-text-[13px] md:gw-text-[14px]"
                  >{{
                    'features.dashboard.recipient.kpi.netRevenue' | translate
                  }}</span
                >
                <span
                  class="gw-text-text-primary gw-text-[14px] md:gw-text-[16px] gw-font-bold"
                  >{{
                    formatCurrency(+(selectedStat?.incomeNetVolume ?? 0))
                  }}</span
                >
              </div>
              <div
                class="metric-divider gw-p-small md:gw-p-medium gw-flex gw-flex-col gw-gap-3x-small"
              >
                <span
                  class="gw-text-text-secondary gw-text-[13px] md:gw-text-[14px]"
                  >{{
                    'features.dashboard.recipient.kpi.withdrawalCount'
                      | translate
                  }}</span
                >
                <span
                  class="gw-text-text-primary gw-text-[14px] md:gw-text-[16px] gw-font-bold"
                  >{{ selectedStat?.cashOutCount ?? 0 }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="gw-flex gw-flex-col gw-border-base gw-mt-x-large">
          <div
            class="gw-flex gw-flex-col md:gw-flex-row gw-justify-between gw-items-start md:gw-items-center gw-gap-small gw-p-small md:gw-p-medium"
          >
            <div class="gw-gap-[8px] gw-flex gw-flex-col">
              <h2 class="gw-text-text-primary gw-text-[14px]">
                {{ 'features.dashboard.recipient.chart.title' | translate }}
              </h2>
              <span class="gw-text-text-secondary gw-text-[14px]">
                {{ 'features.dashboard.recipient.chart.subtitle' | translate }}
              </span>
            </div>
          </div>

          <div class="section-divider">
            <div class="gw-p-small md:gw-p-medium">
              <div class="chart-container">
                <tui-axes
                  [axisXLabels]="chartAxisXLabels"
                  [axisYLabels]="chartAxisYLabels"
                  [horizontalLines]="4"
                  [horizontalLinesHandler]="horizontalLinesHandler"
                  axisX="none"
                  axisY="none"
                  [axisYInset]="true"
                >
                  <tui-bar-chart
                    class="chart"
                    [value]="chartValue"
                    [max]="chartMax"
                    size="m"
                  ></tui-bar-chart>
                </tui-axes>
              </div>

              <div class="gw-flex gw-flex-wrap gw-gap-medium gw-mt-small">
                @for (key of chartLegendI18nKeys; track key; let idx = $index) {
                <tui-legend-item
                  [active]="activeChartLegend[idx]"
                  [color]="chartColors[idx]"
                  [text]="key | translate"
                  size="s"
                  (click)="onChartLegendToggle(idx)"
                ></tui-legend-item>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="!isMobile || mobileDashboardTab === 'atividade'"
      [@mobileTabPanel]
      class="md:gw-pl-medium md:gw-py-x-large gw-flex gw-flex-col"
    >
      <ng-container
        *ngTemplateOutlet="
          notificationPreview;
          context: {shellClass: 'gw-hidden md:gw-block'}
        "
      ></ng-container>

      <div class="gw-p-medium gw-border-base gw-mb-x-large">
        <div class="gw-flex gw-items-center gw-gap-small gw-mb-medium">
          <gatewee-icon
            icon="@tui.triangle-alert"
            class="gw-text-status-warning"
            size="24px"
          ></gatewee-icon>
          <div class="gw-flex gw-flex-col gw-gap-4x-small">
            <span class="gw-text-text-secondary gw-text-[14px]">{{
              'features.dashboard.cards.pendingBalance' | translate
            }}</span>
            <span class="gw-text-text-primary gw-text-[16px] gw-font-bold">{{
              wallet?.pendingBalance
                | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
            }}</span>
          </div>
        </div>
        <span class="gw-text-text-secondary gw-text-[14px]">{{
          'features.dashboard.recipient.pendingBalanceHint' | translate
        }}</span>
      </div>

      <div class="gw-p-medium gw-border-base gw-mb-x-large">
        <div class="gw-flex gw-flex-col gw-gap-small gw-mb-medium">
          <div class="gw-flex gw-flex-col gw-gap-4x-small gw-mb-medium">
            <span class="gw-text-text-primary gw-text-[16px] gw-font-bold">{{
              'features.dashboard.recipient.latestTx.title' | translate
            }}</span>
            <span class="gw-text-text-secondary gw-text-[14px]">{{
              'features.dashboard.recipient.latestTx.subtitle' | translate
            }}</span>
          </div>

          <!--Skeleton loading -->
          <div *ngIf="!transactions" class="gw-flex gw-flex-col gw-gap-small">
            <div
              *ngFor="let s of [1, 2, 3, 4, 5]"
              class="gw-p-small gw-bg-background-neutral-1 gw-rounded-2xl gw-flex gw-items-center gw-gap-small"
            >
              <div class="skeleton skeleton--circle"></div>
              <div class="gw-flex gw-flex-col gw-gap-[6px] gw-flex-1">
                <div class="skeleton skeleton--text-lg"></div>
                <div class="skeleton skeleton--text-sm"></div>
              </div>
              <div class="gw-flex gw-flex-col gw-items-end gw-gap-[6px]">
                <div class="skeleton skeleton--amount"></div>
                <div class="skeleton skeleton--badge"></div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="transactions && hasTransactions">
            <div
              class="tx-carousel-shell"
              [class.tx-carousel-shell--active]="txTotalPages > 1"
            >
              <button
                *ngIf="txTotalPages > 1"
                type="button"
                class="tx-arrow tx-arrow--outside"
                [disabled]="txPage === 0"
                (click)="goToTxPage(txPage - 1)"
              >
                <gatewee-icon
                  icon="@tui.chevron-left"
                  size="16px"
                ></gatewee-icon>
              </button>

              <div class="tx-carousel">
                <div
                  class="tx-carousel__track"
                  [style.transform]="'translateX(-' + txPage * 100 + '%)'"
                >
                  <div
                    *ngFor="
                      let page of [].constructor(txTotalPages);
                      let pi = index;
                      trackBy: trackByPageIndex
                    "
                    class="tx-carousel__page"
                  >
                    <ng-container
                      *ngFor="
                        let tx of transactions!.records
                          | slice
                            : pi * txPageSize
                            : pi * txPageSize + txPageSize;
                        trackBy: trackByTxId
                      "
                    >
                      <div
                        [@txRow]
                        class="gw-p-small gw-bg-background-neutral-1 gw-rounded-2xl gw-flex gw-flex-col"
                      >
                        <a
                          [routerLink]="['/panel/transactions/view', tx.id]"
                          class="gw-flex gw-items-center gw-gap-small gw-w-full"
                        >
                          <gatewee-icon
                            *ngIf="(tx.type | transactionType : true) === 'OUT'"
                            icon="@tui.trending-down"
                            size="24px"
                            iconStyle="negative"
                          ></gatewee-icon>
                          <gatewee-icon
                            *ngIf="(tx.type | transactionType : true) === 'IN'"
                            icon="@tui.trending-up"
                            iconStyle="positive"
                            size="24px"
                          ></gatewee-icon>
                          <div class="gw-flex gw-flex-col gw-w-full">
                            <span
                              class="gw-text-text-primary gw-text-[12px] gw-font-bold"
                              >{{
                                (tx.type !== 'cash_out' && tx.invoice
                                  ? tx.invoice?.client?.name?.toUpperCase() ??
                                    ''
                                  : tx.recipient?.name?.toUpperCase() ?? ''
                                ) | reduceName
                              }}
                            </span>
                            <span
                              class="gw-text-text-secondary gw-text-[12px]"
                              >{{
                                (tx.type !== 'cash_out' && tx.invoice
                                  ? tx.invoice?.client?.document ?? ''
                                  : tx.recipient?.document ?? ''
                                ) | document : true
                              }}</span
                            >
                          </div>
                          <div class="gw-flex gw-flex-col gw-fit">
                            <span
                              class="gw-text-text-primary gw-text-[12px] gw-font-bold gw-whitespace-nowrap gw-text-right"
                              [class.gw-text-status-positive]="
                                tx.type === 'income'
                              "
                              [class.gw-text-status-negative]="
                                tx.type !== 'income'
                              "
                              >{{
                                tx.amount
                                  | currency
                                    : 'BRL'
                                    : 'symbol'
                                    : '1.2-2'
                                    : 'pt-BR'
                              }}</span
                            >
                            <span
                              class="gw-text-[10px] gw-text-nowrap gw-text-right"
                              [class.gw-text-status-positive]="
                                tx.type === 'income'
                              "
                              [class.gw-text-status-negative]="
                                tx.type !== 'income'
                              "
                              >{{ tx.type | transactionType }}</span
                            >
                          </div>
                        </a>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>

              <button
                *ngIf="txTotalPages > 1"
                type="button"
                class="tx-arrow tx-arrow--outside"
                [disabled]="txPage === txTotalPages - 1"
                (click)="goToTxPage(txPage + 1)"
              >
                <gatewee-icon
                  icon="@tui.chevron-right"
                  size="16px"
                ></gatewee-icon>
              </button>
            </div>

            <div
              *ngIf="txTotalPages > 1"
              class="gw-flex gw-items-center gw-justify-center gw-gap-[6px] gw-mt-small"
            >
              <button
                *ngFor="let dot of [].constructor(txTotalPages); let i = index"
                type="button"
                (click)="goToTxPage(i)"
                class="tx-dot"
                [class.tx-dot--active]="i === txPage"
              ></button>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="gw-flex gw-flex-col gw-border-base">
        <div
          class="gw-flex gw-flex-col gw-gap-4x-small gw-p-small md:gw-p-medium gw-mb-medium"
        >
          <span class="gw-text-text-primary gw-text-[16px] gw-font-bold">{{
            'features.dashboard.recipient.paymentMix.title' | translate
          }}</span>
          <span class="gw-text-text-secondary gw-text-[14px]">{{
            'features.dashboard.recipient.paymentMix.subtitle' | translate
          }}</span>
        </div>

        <div class="gw-p-medium gw-pt-0">
          @for (inv of invoicesByPayment; track inv.paymentMethod) {
          <div
            class="gw-p-small gw-bg-background-neutral-1 gw-rounded-2xl gw-flex gw-flex-col gw-mb-small last:gw-mb-0"
          >
            <div class="gw-flex gw-items-center gw-gap-small gw-w-full">
              <div class="gw-flex gw-items-center gw-gap-4x-small gw-w-full">
                <gatewee-icon
                  [icon]="
                    paymentMethodIcons[inv.paymentMethod] ??
                    '@phi.circle-dollar-sign'
                  "
                  iconStyle="primary"
                  size="24px"
                ></gatewee-icon>
                <span
                  class="gw-text-text-primary gw-text-[16px] gw-font-bold gw-leading-none gw-self-center"
                >
                  {{
                    paymentMethodLabelKey(inv.paymentMethod)
                      | translate : {method: inv.paymentMethod}
                  }}
                </span>
              </div>
              <div class="gw-flex gw-flex-col gw-fit">
                <span
                  class="gw-text-text-primary gw-text-[14px] gw-font-bold gw-whitespace-nowrap gw-text-right"
                  >{{ inv.percentage }}%</span
                >
                <span
                  class="gw-text-[12px] gw-text-right gw-text-text-secondary gw-whitespace-nowrap"
                  >{{ formatCurrency(inv.totalAmount) }}</span
                >
              </div>
            </div>
          </div>
          } @empty {
          <span class="gw-text-text-secondary gw-text-[13px]">{{
            'features.dashboard.recipient.paymentMix.empty' | translate
          }}</span>
          }
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #notificationPreview let-shellClass="shellClass">
  <div
    *ngIf="latestUnreadNotification as notification"
    [@notifCard]
    class="announcement-stack gw-mb-x-large"
    [ngClass]="shellClass"
    [class.announcement-stack--multiple]="unreadNotificationCount > 1"
  >
    <div
      class="announcement-stack__card gw-p-medium gw-border-base gw-flex gw-items-start gw-gap-small"
    >
      <gatewee-icon
        icon="@tui.info"
        class="gw-text-status-info gw-shrink-0"
        size="24px"
      ></gatewee-icon>
      <div class="gw-min-w-0 gw-flex-1">
        <span
          class="gw-block gw-text-text-primary gw-text-[14px] gw-font-semibold gw-mb-2x-small"
        >
          {{ 'features.notifications.title' | translate }}
        </span>
        <p
          class="gw-text-text-secondary gw-text-[14px] m-0"
          [class.gw-cursor-pointer]="latestNotificationHref"
          routerLink="/panel/notifications"
        >
          {{ notification.body || notification.title }}
        </p>
      </div>
      <a
        *ngIf="unreadNotificationCount > 1"
        routerLink="/panel/notifications"
        class="gw-ml-auto gw-flex gw-items-center gw-gap-2x-small gw-shrink-0 gw-text-[13px] gw-font-medium gw-text-brand-primary gw-no-underline hover:gw-underline"
        (click)="$event.stopPropagation()"
      >
        {{ 'features.notifications.seeAll' | translate }}
        <gatewee-icon
          icon="@tui.chevron-right"
          iconStyle="primary"
          size="16px"
        ></gatewee-icon>
      </a>
    </div>
  </div>
</ng-template>

<app-pix-area
  #pixArea
  [usePageDrawer]="true"
  (pageDrawerOpenChange)="onPixDrawerOpenChange($event)"
></app-pix-area>

<app-bank-slip-area
  #bankSlipArea
  [usePageDrawer]="true"
  [walletId]="billPaymentWalletId"
  (pageDrawerOpenChange)="onBillPaymentDrawerOpenChange($event)"
></app-bank-slip-area>
